module.exports = __webpack_public_path__ + "img/pc_character1@2x.9947ae4e.png";